import {
	AllColors,
	BackgroundColorWhiteOrNone,
	BasicColors,
	ButtonColors,
	ButtonColorsWeb,
	DefaultColors,
	TabColorsKeys,
	TabColorsValues,
} from '../types/colors';

const basicColors: BasicColors = {
	'iShares Blue': 'blue',
	'iShares Purple': 'purple',
	'iShares Pink': 'pink',
	'iShares Yellow': 'yellow',
	'iShares Green': 'green',
};

export const defaultColors: DefaultColors = {
	...basicColors,
	'iShares Gray': 'gray',
};

export const allColors: AllColors = {
	...defaultColors,
	'iShares White': 'white',
};

export const buttonColors: ButtonColors = {
	None: '',
	'iShares White': 'white',
	...basicColors,
};

export const buttonColorsWeb: ButtonColorsWeb = {
	...buttonColors,
	'iShares Black': 'black',
};

export const whiteOrNone: { [index: string]: BackgroundColorWhiteOrNone } = {
	'iShares White': 'white',
	None: '',
};

export const tabColors: { [key in TabColorsKeys]: TabColorsValues } = {
	'iShares Black': 'black',
	'iShares White': 'white',
};

export const brandIntegrationColors = {
	'iShares Blue': 'blue',
	'iShares Purple': 'purple',
	'iShares Green': 'green',
};
